import { CreditCardType } from './type'
import Visual from './Visual'

const CreditCard = ({ paymentMethod }: CreditCardType) => {
  return <Visual paymentMethod={paymentMethod} />
}

export default CreditCard
